module.exports = __webpack_public_path__ + "static/media/children_3x.3bda2be0.png";